import { sendRequest } from '@infrastructure/api/api';
import {
  EntityUserListResponse,
  EntityUserRoleAssignmentListResponse,
} from '../types/user';
import ApiResponse from '@core/types/apiResponse';

const entityPath = (scope: string): string => {
  const entityMap: Record<string, string> = {
    NATION: 'nation',
    DISTRICT: 'district',
    CHURCH: 'church',
  };
  return entityMap[scope] || scope.toLowerCase();
};

/**
 * Removes a user's profile/role from a specific entity.
 * POST /{entity}/{entityId}/user-role-assignments/remove
 */
export const removeEntityUser = async (
  scope: string,
  scopeRefId: number,
  body: { uid: number; role: string; department_id: number }
): Promise<ApiResponse<{ message: string }>> => {
  const entity = entityPath(scope);

  return await sendRequest<typeof body, { message: string }>(
    'POST',
    `/${entity}/${scopeRefId}/user-role-assignments/remove`,
    body
  );
};

/**
 * Fetches people at an entity (person grain).
 * GET /{entity}/{entityId}/users
 */
export const fetchEntityUsers = async (
  scope: string,
  scopeRefId: number,
  params: Record<string, string> = {}
): Promise<ApiResponse<EntityUserListResponse>> => {
  const entity = entityPath(scope);
  const queryString = new URLSearchParams(params);
  return await sendRequest<any, EntityUserListResponse>(
    'GET',
    `/${entity}/${scopeRefId}/users?${queryString}`
  );
};

/**
 * Fetches user-role-assignments at an entity (assignment grain).
 * GET /{entity}/{entityId}/user-role-assignments
 */
export const fetchEntityUserRoleAssignments = async (
  scope: string,
  scopeRefId: number,
  params: Record<string, string> = {}
): Promise<ApiResponse<EntityUserRoleAssignmentListResponse>> => {
  const entity = entityPath(scope);
  const queryString = new URLSearchParams(params);
  return await sendRequest<any, EntityUserRoleAssignmentListResponse>(
    'GET',
    `/${entity}/${scopeRefId}/user-role-assignments?${queryString}`
  );
};
